module.exports = __webpack_public_path__ + "media/images/area/feature/chugoku/related/vi/3-5897613123d463a07c793391c418355e.jpg";